import { Header } from 'components/slider/header';

import { ICasinoReview, IStreamerReview } from 'constants/types';
import { Routes } from 'constants/routes';
import { getItemIdentifier } from 'utils/slug';

import styles from './styles.module.css';
import { ReviewsMasonry } from 'components/reviews-masonry';
import { ReviewsCard } from 'components/cards';

export const TableReviews = ({
  data,
  title,
  type,
  isPublicProfile,
  anchor,
}: {
  data: ICasinoReview[] | IStreamerReview[];
  title: string;
  type: 'casino' | 'streamer';
  isPublicProfile?: boolean;
  anchor?: string;
}) => {
  if (!data?.length) {
    return null;
  }

  return (
    <>
      <section>
        <div className={styles.container_s} id={anchor}>
          {!!title?.length && (
            <Header
              hasIcon={false}
              name={title}
              count={data?.length?.toString() ?? '0'}
              isSmallName
            />
          )}
          <ReviewsMasonry gap="20px">
            {data?.map((item) =>
              type === 'casino' ? (
                <ReviewsCard
                  variant="panel"
                  isProfile
                  isPublicProfile={isPublicProfile}
                  comment={item as ICasinoReview}
                  key={item?._id?.toString()}
                  link={Routes.casinoPage(getItemIdentifier(item?.data))}
                />
              ) : (
                <ReviewsCard
                  isProfile
                  comment={item}
                  key={item?._id?.toString()}
                  link={Routes.streamer(getItemIdentifier(item?.data))}
                />
              )
            )}
          </ReviewsMasonry>
        </div>
      </section>
    </>
  );
};
